import React, { useMemo, useCallback } from "react";

const ProblemsModal = ({ open, problems = [], onClose }) => {
  const safeProblems = useMemo(
    () => (Array.isArray(problems) ? problems : []),
    [problems]
  );

  const hasProblems = safeProblems.length > 0;

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          width: 520,
          maxHeight: "70vh",
          borderRadius: 8,
          padding: 16,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3 style={{ margin: "0 0 8px 0" }}>Problems</h3>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: 12,
            border: "1px solid #eee",
            borderRadius: 6,
            background: "#fafafa",
            marginBottom: 12,
          }}
        >
          {!hasProblems ? (
            <div style={{ color: "#666", fontStyle: "italic" }}>
              No problems to display.
            </div>
          ) : (
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {safeProblems.map((p, i) => (
                <li key={i} style={{ marginBottom: 6 }}>
                  {p}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            onClick={handleClose}
            style={{
              padding: "8px 14px",
              background: "#007bff",
              border: "none",
              borderRadius: 4,
              color: "#fff",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProblemsModal);